// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1-w6a"};